var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnotation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.62027 6.70208H13.059L12.9936 7.43528H2.55487L2.62027 6.70208ZM2.75053 5.23569H14.3225L14.2592 5.96889H2.68513L2.75053 5.23569ZM2.8808 3.7693H13.3201L13.2547 4.50249H2.81593L2.8808 3.7693ZM3.01159 2.30343H14.5809L14.5155 3.03663H2.94834L3.01159 2.30343ZM0.866812 0L0 9.73818H4.29975L7.72786 14.3303L11.9724 9.73818H16.2716L17.1384 0H0.866812Z",
    fill: "#F2962E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48556 20.9855H21.0575L20.9927 21.7155H9.42123L9.48556 20.9855ZM10.748 19.5296H21.1851L21.1208 20.2575H10.6837L10.748 19.5296ZM9.74501 18.0732H21.317L21.2526 18.8012H9.68015L9.74501 18.0732ZM11.008 16.6174H21.4462L21.3818 17.3453H10.9431L11.008 16.6174ZM12.0265 14.3308H7.72996L6.86743 24H23.1396L24 14.3303H19.7002L16.2694 9.77087L12.0265 14.3308Z",
    fill: "#F2962E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotation);
export default __webpack_public_path__ + "static/media/annotation.0866dd37495cf686380946a0a063aad5.svg";
export { ForwardRef as ReactComponent };